import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { OrderSummaryData } from '../../models/order-summary-data';

@Component({
    selector: 'app-order-summary-header',
    templateUrl: './order-summary-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonModule,
    ],
})
/**
 * Reusable header shared across Order Details and Payment Details pages, displaying
 * billing address, order information, and the applicant table.
 *
 * @input orderSummaryData - The flattened order/billing data to display across all sections.
 * @input cityStateZip - Pre-formatted city, state, and zip string for the billing address.
 * @input showEditButton - Whether to show the Edit button on the Bill To card.
 */
export class OrderSummaryHeaderComponent {
    @Input() orderSummaryData: OrderSummaryData = {} as OrderSummaryData;
    @Input() cityStateZip = '';
    @Input() showEditButton = false;

    @Output() editBillingInformation = new EventEmitter<void>();

    onEditBillingInformationClick(): void {
        this.editBillingInformation.emit();
    }
}
